<template>
  <div class="home flex-wrap flex-vertical">
    <!-- <van-nav-bar
      title="真伪查询结果"
      :fixed="true"
      :placeholder="true"
      left-arrow
      @click-left="onClickLeft"
      :safe-area-inset-top="true"
    /> -->

    <div class="flex-con home1">
      <img
        src="@/assets/success.png"
        alt="龙蟠科技"
        class="success-img"
        v-if="codeStart == 1"
      />
      <img
        src="@/assets/error.png"
        alt="龙蟠科技"
        class="error-img"
        v-if="codeStart == 0"
      />
      <img
        src="@/assets/repeat.png"
        alt="龙蟠科技"
        class="repeat-img"
        v-if="codeStart == 2"
      />
      <div class="content" v-if="codeStart == 1">
        <div class="welcome">This Product is Genuine！</div>
        <div class="text1">This Anti-Spoofing Code Is First Query</div>
      </div>
      <div class="content" v-if="codeStart == 0">
        <div class="welcome" style="color: #bc0202">Check for this code,<br>beware of forgeries!</div>
        <div class="text1 text2">
          The counterfeiting code you are requesting does not exist. Please be careful that this product is a counterfeit product.
        </div>
      </div>
      <div class="content" v-if="codeStart == 2">
        <div class="welcome" style="color: #ffaf00">Repeating Queries</div>
        <div class="text1" style="margin: 28px 0 43px;">This Anti-Spoofing Code is the {{ codeSelectCount }}th Query</div>
        <div class="text3">
          First Query Time: {{ codeFirstTime }} <br />
          The anti-fake code is valid for only one query. The anti-fake code you are requesting is for multiple queries.<br />
          If the time of your first query does not match the above time, please be careful, guard against forgery!
          


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Result',

  data() {
    return {
      id: '', // | string | 码库记录 ID（未查到时通常无该字段） |
      codeStart: '', // | number | 真伪状态：`0=未查到（疑似假码）`，`1=真码且首次查询`，`2=真码且多次查询` |
      codeFirstTime: '', //` | string | 首次查询时间 |
    }
  },

  mounted() {
    this.id = this.$route.query.id
    this.codeStart = this.$route.query.codeStart
    this.codeFirstTime = this.$route.query.codeFirstTime
    this.codeSelectCount = this.$route.query.codeSelectCount
  },

  methods: {
    onClickLeft() {
      this.$router.go(-1) // 返回上一页
    },
  },
}
</script>
<style scoped>
::v-deep.van-nav-bar__title {
  font-size: 18px;
  font-weight: 800;
}
::v-deep .van-nav-bar .van-icon {
  color: #333;
  font-size: 24px;
}
.title1 {
  width: 100%;
  line-height: 50px;
  text-align: center;
  position: relative;
  background-color: #fff;
}
.arrow_left {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 15px;
  top: 13px;
}
.text3 {
  padding: 0 30px;
  text-align: left;
  font-weight: normal;
  font-size: 14px;
  color: #001d1d;
  line-height: 20px;
}
.home {
  height: 100vh;
}

.home1 {
  background: url('@/assets/bg1.png') no-repeat center center;
  background-size: 100% 100%;

  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.success-img {
  display: block;
  width: 140px;
  max-width: 140px;
  height: 94px;
  margin: 96px auto 20px;
}
.error-img {
  display: block;
  width: 143px;
  max-width: 143px;
  height: 102px;
  margin: 96px auto 17px;
}

.repeat-img {
  display: block;
  width: 120px;
  max-width: 120px;
  height: 106px;
  margin: 96px auto 6px;
}

.content {
}

.welcome {
  font-weight: normal;
  font-size: 28px;
  color: #007D4F;
  line-height: 40px;
  text-align: center;
  margin-bottom: 18px;
}

.text1 {
  font-weight: normal;
  font-size: 16px;
  color: #001d1d;
  text-align: center;
  line-height: 22px;
}

.text2 {
  margin-top: 57px;
  text-align: left;
  padding: 0 30px;
  font-size: 14px;
  color: #001D1D;
  line-height: 20px;
}
</style>
